import React from 'react';
import { IconProps } from '../types';

export const Circles: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5 19V26M26 22.5H19M14 9.5C14 11.9853 11.9852 14 9.49995 14C7.01467 14 4.99995 11.9853 4.99995 9.5C4.99995 7.01472 7.01467 5 9.49995 5C11.9852 5 14 7.01472 14 9.5ZM27 9.5C27 11.9853 24.9852 14 22.5 14C20.0147 14 18 11.9853 18 9.5C18 7.01472 20.0147 5 22.5 5C24.9852 5 27 7.01472 27 9.5ZM14 22.5C14 24.9853 11.9852 27 9.49995 27C7.01467 27 4.99995 24.9853 4.99995 22.5C4.99995 20.0147 7.01467 18 9.49995 18C11.9852 18 14 20.0147 14 22.5Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
